module.exports = __webpack_public_path__ + "img/ajsk1.89cdebf7.jpg";